import React from 'react';

import Tag from '@atlaskit/tag/removable-tag';

export default (): React.JSX.Element => <Tag text="Design" isRemovable={false} />;
